import { useEffect, useRef, useState } from "react";
import { Avatar, Layout, Menu } from "antd";
import {
  DownOutlined,
  UserOutlined,
  UnlockOutlined,
  LoginOutlined,
} from "@ant-design/icons";
import ChangePassword from "../../Modal/ChangePassword";
import * as Utils from "../../utils/helper/utils";
import * as Auth from "../../utils/helper/auth";
import Logout from "../../Modal/Logout";
import { useSocketContext } from "../../context/SocketContext";
import toast from "react-hot-toast";
import EnableNotification from "../../Modal/EnableNotification";

const { Header } = Layout;
const HeaderComponent = () => {
  const [isEnableNotificationModel, setEnableNotificationModel] =
    useState(true);
  const [isChangePasswordModalOpen, setIsChangePasswordModalOpen] =
    useState(false);
  const [isLogoutModalOpen, setIsLogoutModalOpen] = useState(false);
  const [name, setName] = useState("");
  const showChangePasswordModal = () => {
    setIsChangePasswordModalOpen(true);
  };
  const handleChangePasswordOk = () => {
    setIsChangePasswordModalOpen(false);
  };
  const handleChangePasswordCancel = () => {
    setIsChangePasswordModalOpen(false);
  };
  const showLogoutModal = () => {
    setIsLogoutModalOpen(true);
  };
  const handleLogoutOk = () => {
    localStorage.removeItem("redirectAfterLogin"); // Clean up
    localStorage.removeItem("lang");
    setIsLogoutModalOpen(false);
    Utils.clearLocalData();
    window.location.reload();
  };
  const handleLogoutCancel = () => {
    setIsLogoutModalOpen(false);
  };

  useEffect(() => {
    let adminName = Auth.authData();
    adminName = adminName?.user?.firstName + " " + adminName?.user?.lastName;
    setName(adminName);
  }, []);

  const audioRef = useRef(null);
  const enableAudioPlayback = () => {
    const audio = new Audio("/audio/notification.mp3"); // Replace with your file path
    audioRef.current = audio;
    //console.log("Audio preloaded and ready to play.");
  };
  const playSound = () => {
    try {
      if (!audioRef.current) {
        audioRef.current = new Audio("/audio/notification.mp3");
      }
      audioRef.current.currentTime = 0;
      audioRef.current
        .play()
        .then(() => {
          //console.log("Audio playback started.");
        })
        .catch((error) => {
          //console.error("Audio playback failed:", error);
        });
    } catch (e) {
      console.error("Audio playback error:", e);
    }
  };

  const { socket } = useSocketContext();
  useEffect(() => {
    if (!socket) return;

    const handleNotification = (data) => {
      const userData = JSON.parse(localStorage.getItem("userData") || "{}");
      const authUser = Auth.authData()?.user;
      const roleId = userData?.roleId || authUser?.roleId;
      const userRole = userData?.role || (roleId === 5 ? "subadmin" : "admin");

      if (userRole === "admin") {
        toast.success(data?.message, {
          duration: 7000,
        });
        playSound();
        return;
      }

      if (userRole === "subadmin") {
        const rawBranchIds = userData?.branch_ids;
        const rawDropzoneIds = userData?.dropzone_id;

        const branchIds = Array.isArray(rawBranchIds) ? rawBranchIds.map(String).filter(Boolean) : [];
        const dropzoneIds = Array.isArray(rawDropzoneIds) ? rawDropzoneIds.map(String).filter(Boolean) : [];

        const hasAssignedBranches = branchIds.length > 0;
        const hasAssignedDropzones = dropzoneIds.length > 0;

        if (!hasAssignedBranches && !hasAssignedDropzones) {
          return;
        }

        const orderBranchId = data?.branchId && String(data?.branchId) !== "0" ? String(data?.branchId) : null;
        const orderDropzoneId = data?.dropzoneId && String(data?.dropzoneId) !== "0" ? String(data?.dropzoneId) : null;

        const branchMatch = Boolean(orderBranchId && hasAssignedBranches && branchIds.includes(orderBranchId));
        const dropzoneMatch = Boolean(orderDropzoneId && hasAssignedDropzones && dropzoneIds.includes(orderDropzoneId));

        if (branchMatch || dropzoneMatch) {
          toast.success(data?.message, { duration: 7000 });
          playSound();
        }
      }
    };

    //setting All Events
    socket.on("welcome", handleNotification);
    socket.on("NewOrderCreated", handleNotification);
    socket.on("customerAcceptOrder", handleNotification);
    socket.on("customerRejectOrder", handleNotification);
    socket.on("QcRequestSubmitted", handleNotification);
    socket.on("QCAcceptedOrder", handleNotification);
    socket.on("QCRejectedOrder", handleNotification);
    socket.on("QCApproveItemRequest", handleNotification);
    socket.on("QCRejectItemRequest", handleNotification);

    return () => {
      socket.off("welcome", handleNotification);
      socket.off("NewOrderCreated", handleNotification);
      socket.off("customerAcceptOrder", handleNotification);
      socket.off("customerRejectOrder", handleNotification);
      socket.off("QcRequestSubmitted", handleNotification);
      socket.off("QCAcceptedOrder", handleNotification);
      socket.off("QCRejectedOrder", handleNotification);
      socket.off("QCApproveItemRequest", handleNotification);
      socket.off("QCRejectItemRequest", handleNotification);
    };
  }, [socket]);

  const handelEnableNotificationModelOk = () => {
    enableAudioPlayback();
    setEnableNotificationModel(false);
  };
  const handelEnableNotificationModelCancel = () => {
    setEnableNotificationModel(false);
  };

  return (
    <>
      <div>
        <Header
          style={{ background: "#fff", padding: "0px 16px" }}
          className="sticky top-0 z-50"
        >
          <div className="text-right">
            <Menu mode="horizontal" className="ml-auto flex justify-end">
              <Menu.SubMenu
                key="SubMenu"
                title={
                  <>
                    <span
                      className="cursor-pointer inline-block"
                      onClick={(e) => e.preventDefault()}
                    >
                      <Avatar size={40} icon={<UserOutlined />} />
                      <span className="mx-2">{name}</span>
                      <DownOutlined />
                    </span>
                  </>
                }
              >
                <Menu.Item>
                  <UserOutlined className="mr-1" /> Profile
                </Menu.Item>
                <Menu.Item onClick={showChangePasswordModal}>
                  <UnlockOutlined className="mr-1" /> Change Password
                </Menu.Item>
                <Menu.Item onClick={showLogoutModal}>
                  <LoginOutlined className="mr-1" /> Logout
                </Menu.Item>
              </Menu.SubMenu>
            </Menu>
          </div>
        </Header>
        <ChangePassword
          isOpen={isChangePasswordModalOpen}
          onOk={handleChangePasswordOk}
          onCancel={handleChangePasswordCancel}
        />
        <Logout
          ConfirmationHeading="Logout"
          ConfirmationParagraph="Are you sure you want to logout?"
          isOpen={isLogoutModalOpen}
          onOk={handleLogoutOk}
          onCancel={handleLogoutCancel}
        />
        {isEnableNotificationModel && (
          <EnableNotification
            isOpen={isEnableNotificationModel}
            onOk={handelEnableNotificationModelOk}
            onCancel={handelEnableNotificationModelCancel}
          />
        )}
      </div>
    </>
  );
};
export default HeaderComponent;
